import React, { ReactElement } from 'react';
import {
  Col, Heading, Row, Tag,
} from 'idsk-react-components';
import PripomienkaDetail from '../../../model/pripomienka/PripomienkaDetail';
import PripomienkaDetailRow from './PripomienkaDetailRow';
import ClassType from '../../../model/pripomienka/ClassType';
import { PodporovatelList } from '../../PodporovatelList';
import { stavPripomienkyToTagClass } from '../../../model/pripomienka/StavPripomienky';
import ActionButtons from './ActionButtons';
import PripomienkaDetailPagination from './PripomienkaDetailPagination';
import UserRole from '../../../model/currentuser/UserRole';
import Secured from '../../Secured';

interface Props {
  classType: ClassType;
  pripomienkaDetail: PripomienkaDetail;

  reloadPripomienkaDetail(): void;
}

const VyhodnotenieDetailSection = ({
  classType,
  pripomienkaDetail,
  reloadPripomienkaDetail,
}: Props): ReactElement => pripomienkaDetail && (
<>
  {pripomienkaDetail.stav && (
    <section className="vyhodnotenie-detail-section">
      <Row>
        <Col>
          <Heading size="m">VYHODNOTENIE</Heading>
        </Col>
      </Row>
      <Secured allowForRoles={[UserRole.VYHODNOCOVATEL, UserRole.SUPERADMIN]}>
        {pripomienkaDetail.priradeny?.fullName
          ? <PripomienkaDetailRow header="Priradená:" data={pripomienkaDetail.priradeny.fullName} />
          : <PripomienkaDetailRow header="Priradená:" data="Nepriradená" />}
      </Secured>
      <PripomienkaDetailRow
        header="Vyhodnotil používateľ:"
        data={pripomienkaDetail.vyhodnotil ? pripomienkaDetail.vyhodnotil.fullName : null}
      />
      {pripomienkaDetail.stav && (
      <Row className="pripomienka-detail-row">
        <Col width="one-quarter">
          <span className="information-header">Vyhodnotenie:</span>
        </Col>
        <Col width="three-quarters">
          <Tag
            size="small"
            type={stavPripomienkyToTagClass(pripomienkaDetail.stav)}
          >
            {pripomienkaDetail.stav}
          </Tag>
        </Col>
      </Row>
      )}
      <PripomienkaDetailRow
        header="Text vyhodnotenia:"
        data={pripomienkaDetail.textVyhodnotenia}
      />
    </section>
  )}
  {classType === ClassType.HROMADNA_PRIPOMIENKA && (
  <PodporovatelList />
  )}
  <ActionButtons
    classType={classType}
    pripomienkaDetail={pripomienkaDetail}
    reloadPripomienkaDetail={reloadPripomienkaDetail}
  />
  <PripomienkaDetailPagination
    pripomienkaDetail={pripomienkaDetail}
  />
</>
);

export default VyhodnotenieDetailSection;
